import { api_request } from '../../../Services/helpers'

export const fetchSearchLocation = async (params = {}) =>
  await api_request('post', '/auth/searches/location', params, true)

export const fetchSearchCaravan = async (params = {}) =>
  await api_request('post', '/auth/searches/caravan', params, true)
